import React from 'react';
import { Check } from 'lucide-react';

// The two halves of Korsa: what you wear and what you drive it from. Photos
// live in public/photos/. Each product is its own panel: the copy sits in an
// info column on the left and the photo sits, uncropped-feeling, on the right.
// `focus` keeps the subject in frame when object-cover crops.
const PRODUCTS = [
  {
    eyebrow: 'Hardware',
    title: 'Glasses',
    photo: '/photos/glasses-lifestyle.jpg',
    alt: 'A man wearing Korsa Glasses in a meeting',
    focus: 'object-center',
    points: [
      'Look like ordinary glasses, all day',
      'Live captions, translation, and teleprompter',
      'Prescription lenses available',
    ],
  },
  {
    eyebrow: 'Software',
    title: 'App',
    photo: '/photos/app-phone.jpg',
    alt: 'The Korsa app on an iPhone home screen',
    focus: 'object-right',
    points: [
      'Review transcripts and summaries',
      'Add abilities from the marketplace',
      'Updates arrive over the air',
    ],
  },
];

// Shared by the home page and the order page. `id` is optional so only the
// home page claims the /#products anchor.
export const ProductCards = ({ id }) => (
  <section id={id} className="py-16 md:py-24 px-4 md:px-6 scroll-mt-24">
    <div className="max-w-[1400px] mx-auto space-y-4 md:space-y-5">
      {PRODUCTS.map((p) => (
        <div key={p.title} className="glass px-8 md:px-16 py-12 md:py-16">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">

            {/* Info on the left */}
            <div className="max-w-xl">
              <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-zinc-500 mb-4">
                {p.eyebrow}
              </p>
              <h3 className="text-3xl md:text-5xl font-bold tracking-tighter uppercase text-zinc-900">
                {p.title}
              </h3>
              <ul className="mt-8 space-y-3">
                {p.points.map((point) => (
                  <li key={point} className="flex items-start gap-3">
                    <Check size={16} strokeWidth={2.6} className="mt-1 shrink-0 text-zinc-900" />
                    <span className="text-sm md:text-base text-zinc-700 leading-relaxed">
                      {point}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Image on the right. Photos are 4:5 portrait, so the frame matches them
                to fill cleanly with almost no crop. */}
            <div className="group relative overflow-hidden rounded-[2rem] border border-white/70 aspect-[4/5] shadow-[0_12px_40px_rgba(31,38,135,0.10)]">
              <img
                src={p.photo}
                alt={p.alt}
                loading="lazy"
                className={`absolute inset-0 w-full h-full object-cover ${p.focus} transition-transform duration-700 ease-out group-hover:scale-[1.03]`}
              />
            </div>

          </div>
        </div>
      ))}
    </div>
  </section>
);

export default ProductCards;
